import React from "react";
import { carImageUrl } from "../../utils";
import { useTranslation } from "react-i18next";
import svg_icon from "../../Assets/svg_icon";

import "swiper/css";
import "swiper/css/navigation";
import { carDetailsNoCar } from "./ImageList";
import { getBookingPrice } from "../../Components/components";

export const ArrowBtn = ({ className, type, style, onClick }) => {
  return (
    <div
      className={`${className} Sample${type}Arrow`}
      style={{ ...style }}
      onClick={onClick}
    >
      {svg_icon?.slider_Arrow_Icon}
    </div>
  );
};

// Card
export const SelectedColorCarList = ({
  className,
  transmissionType,
  isSelected,
  onClick,
  data,
  ele,
  date,
}) => {
  const { t } = useTranslation();
  const { modelYear, fuelType, requireApproval, _id, color, premiumCar } = ele;
  const { pickUpDate, dropOffDate } = date || {};
  const fuelType2 =
    String(fuelType).charAt(0).toUpperCase() + fuelType?.slice(1).toLowerCase();

  const hourlyRate = getBookingPrice({
    date: { startDate: pickUpDate, endDate: dropOffDate },
    data: ele,
  });

  return (
    <div
      className={`${className} SelectedColorCarCard ${
        isSelected === true ? "active" : ""
      } position-relative h-100`}
      onClick={onClick}
      value={_id}
      data-set={_id}
    >
      <div
        className={`border-n text-center p-3 h-100 ${
          premiumCar === true
            ? "c-primary listOfCarStyle premiumCar"
            : "c-primary-opacity"
        }`}
      >
        {isSelected === true && (
          <div className="multiColorCarIsSelected isSelectedIcon">
            {svg_icon?.multiColorCarIsSelected}
          </div>
        )}

        {data !== undefined &&
          data?.data
            ?.filter((ele1) => {
              return ele1?._id === _id;
            })
            .map((ele1, index) => {
              return (
                <div className="searchCarImageSection" key={index}>
                  {ele1?.photos?.length === 0 ? (
                    <img
                      src={carDetailsNoCar}
                      alt=""
                      className="img-fluid border-1 border-s mb-2"
                    />
                  ) : (
                    <img
                      src={`${carImageUrl}/${ele1?.photos[0]?.url}`}
                      alt=""
                      className="img-fluid border-1 border-s mostPopularBookingImage mb-2 bg-white"
                      onError={(event) => (event.target.src = carDetailsNoCar)}
                    />
                  )}
                </div>
              );
            })}
        <div
          className="d-flex align-items-center justify-content-center mb-3 flex-wrap mt-3 FeatureList"
          style={{ gap: "0.5rem" }}
        >
          <div className="border-1 border-s bg-white px-2 py-2 d-flex align-items-center">
            {/* <img src={CarTransmissionType} className="img-fluid" alt="Gar Type" /> */}
            {svg_icon?.transmissionType}
            <span className="ms-1 f12">
              {transmissionType === "A"
                ? t("labels.automatic")
                : t("labels.manual")}{" "}
            </span>
          </div>
          <div className="border-1 border-s bg-white px-2 py-2 d-flex align-items-center">
            {/* img src={FuelType} className="img-fluid" alt="Gar Type" /> */}
            {svg_icon?.upl_fuelType}
            <span className="ms-1 f12">
              {fuelType === "ev" ? fuelType.toUpperCase() : t(fuelType2)}
            </span>
          </div>
          {data?.color
            .filter((ele1) => {
              return (ele1?._id === color) === true && ele1;
            })
            .map((ele2, index) => {
              return (
                <div
                  className="border-1 border-s bg-white px-2 py-2 d-flex align-items-center carColor"
                  key={index}
                >
                  <span
                    className="d-inline-block"
                    style={{
                      backgroundColor: ele2?.hex,
                      width: 14,
                      height: 14,
                      borderRadius: "50%",
                      border: "1px solid rgba(0, 0, 0, 0.5)",
                      verticalAlign: "middle",
                    }}
                  />
                  <span className="f12 ms-1">{ele2?.name}</span>
                </div>
              );
            })}
        </div>
        <p className="ff_bd f14 mb-0">
          €{hourlyRate} {t("labels.perDay")}
        </p>
        <p className="AirbnbCereal_W_Xd f12 mb-0">
          {modelYear} {t("labels.model")}
        </p>
        {requireApproval && (
          <p className="AirbnbCereal_W_Xd f12 border-1 border-s bg-white text-center px-2 py-1 mt-2 text-danger">
            {t("labels.requireApprovalAfter")}
          </p>
        )}
      </div>
    </div>
  );
};
